import React from 'react';
import { FeatureToggleProviderAutomatic } from '@cnx-saas/feature-toggle';
import { GlobalProvider } from '@cnx-saas/common-fe';
import { AuthProvider } from '@cnx-saas/react-auth';
import { GlobalStyle, ThemeProvider } from '@cnx-saas/design-system';
import { SnackbarProvider } from '@cnx-saas/snackbar';
import { apiClient } from '../api/tenant';
import { AppWrapper } from './app-wrapper';
import { AppContextProvider } from './app.context';
import { StyledAppContainer } from './app.style';

const App = () => {
  return (
    <GlobalProvider
      apolloClient={apiClient.getClient()}
      i18nConfig={{
        namespace: 'translations',
        locizeApiKey: process.env.LOCIZE_API_KEY || '',
        locizeProjectId: process.env.LOCIZE_PROJECT_ID || '',
      }}
    >
      <AuthProvider>
        <FeatureToggleProviderAutomatic>
          <AppContextProvider>
            <ThemeProvider>
              <SnackbarProvider>
                <GlobalStyle />
                <StyledAppContainer data-testid="saas-fe-app">
                  <AppWrapper />
                </StyledAppContainer>
              </SnackbarProvider>
            </ThemeProvider>
          </AppContextProvider>
        </FeatureToggleProviderAutomatic>
      </AuthProvider>
    </GlobalProvider>
  );
};

export { App };
